import { WIDGET_LOG, WIDGET_EVENT } from '@/store/global';

function buildPayload(action, source) {
  return {
    action: action || null,
    source,
    isFrame: window.self !== window.top,
  };
}

export async function redirectTo3ds({
  dispatch,
  action,
  transactionId,
  source,
}) {
  const payload = buildPayload(action, source);

  if (!action) {
    dispatch(
      'sendLog',
      {
        logType: WIDGET_LOG.ERROR,
        message: '3DS redirect missing action URL',
        details: {
          transactionId,
          event: WIDGET_EVENT.THREEDS_REDIRECT_STALLED,
          eventUTC: new Date().toISOString(),
          payload,
        },
      },
      { root: true },
    );
    return;
  }

  await dispatch(
    'sendLog',
    {
      logType: WIDGET_LOG.INFO,
      message: 'Widget attempting 3DS redirect',
      details: {
        transactionId,
        event: WIDGET_EVENT.THREEDS_REDIRECT_ATTEMPT,
        eventUTC: new Date().toISOString(),
        payload,
      },
    },
    { root: true },
  );

  const stalledTimer = setTimeout(() => {
    dispatch(
      'sendLog',
      {
        logType: WIDGET_LOG.ERROR,
        message: '3DS redirect did not navigate away',
        details: {
          transactionId,
          event: WIDGET_EVENT.THREEDS_REDIRECT_STALLED,
          eventUTC: new Date().toISOString(),
          payload,
        },
      },
      { root: true },
    );
  }, 7000);

  window.addEventListener('pagehide', () => clearTimeout(stalledTimer), {
    once: true,
  });

  window.location.href = action;
}
